import { useEffect, useRef } from 'react';

export default function FastDeliverySection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const els = entry.target.querySelectorAll('.reveal');
            els.forEach((el, i) => {
              setTimeout(() => {
                el.classList.add('animate-in');
              }, i * 100);
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-6 max-w-[1450px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
          <div className="order-2 md:order-1">
            <h2 className="reveal opacity-0 translate-y-4 transition-all duration-700 ease-out font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-6">
              BRZA ISPORUKA
            </h2>
            <p className="reveal opacity-0 translate-y-4 transition-all duration-700 delay-100 ease-out text-base text-foreground-700 leading-relaxed">
              Kućne brojeve, pločice za vrata, sa prezimenom ili za poštansko sanduče, postavke šaljemo svakog radnog dana putem brze pošte. Na vašoj adresi su u roku od 2 do 3 radna dana od dana porudžbine.
            </p>
          </div>

          <div className="order-1 md:order-2 reveal opacity-0 translate-y-4 transition-all duration-700 ease-out bg-background-200 rounded-lg overflow-hidden min-h-[300px] border border-background-300/60">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20premium%20house%20number%20product%20box%20being%20delivered%20by%20courier%2C%20modern%20cardboard%20packaging%20with%20minimalist%20branding%2C%20clean%20white%20studio%20background%2C%20professional%20product%20photography%20with%20soft%20lighting%2C%20delivery%20service%20concept&width=800&height=600&seq=fast-delivery-2026&orientation=landscape"
              alt="Brza isporuka"
              className="w-full h-full min-h-[300px] object-cover rounded-lg"
            />
          </div>
        </div>
      </div>

      <style>{`
        .reveal.animate-in {
          opacity: 1;
          transform: translateY(0);
        }
      `}</style>
    </section>
  );
}